import styles from "./pit-wall.module.scss"
import { useState, useEffect } from "react"

// Bios
import bios from "./assets/bios.json"
import { pictures } from "./assets/pictures/pictures"

// Images
import PitWallImage from "../../../../assets/images/graphics/pit_wall.png"
import OpenIcon from "../../../../assets/images/icons/touchpoint.svg"
import Close from "../../../../assets/images/icons/close.svg"

import { CosmosText, CosmosTitle } from "@cosmos/web-react"

// Returns the HTML markup for the ops room slide
export default function PitWall() {
	const [modalToggled, setModalToggled] = useState(false)
	const [activeProfile, setActiveProfile] = useState(null)

	// When the modalToggled state is changed
	useEffect(() => {
		if (!modalToggled) {
			setTimeout(() => {
				setActiveProfile(null)
			}, 350)
		}
	}, [modalToggled])

	return (
		<>
			<div className={styles.container}>
				<CosmosTitle
					size="xx-large"
					className={styles.title}>
					OUR PIT WALL
				</CosmosTitle>

				<img
					className={styles.pitwall}
					src={PitWallImage}
					alt="Pit Wall"
				/>

				<div className={styles.personToggles}>
					{bios.map((bio, index) => (
						<div
							key={index}
							className={styles.toggle}
							style={{
								backgroundImage: `url(${OpenIcon})`,
								left: `${bio.position.left}vw`,
								top: `${bio.position.top}vh`,
							}}
							onClick={() => {
								setModalToggled(true)
								setActiveProfile(bio)
							}}
						/>
					))}
				</div>
			</div>

			<div
				className={[styles.modal, modalToggled ? styles.isToggled : ""].join(" ")}
				onClick={() => setModalToggled(false)}>
				<div className={styles.card}>
					<img
						className={styles.closeTouchpoint}
						src={Close}
						alt="Close"
					/>

					<div className={styles.grid}>
						<div className={styles.imageContainer}>
							<img
								className={styles.pictureProfile}
								src={`${pictures[activeProfile?.image]}`}
							/>
						</div>

						<div className={styles.textContainer}>
							<div className={styles.name}>
								<CosmosTitle
									weight="heavy"
									size="medium">
									{activeProfile?.name}
								</CosmosTitle>
							</div>

							<div className={styles.bio}>
								<CosmosText size="medium">
									Position On Pit Wall:
									<br />
									<span>{activeProfile?.pit_position}</span>
								</CosmosText>

								{activeProfile?.fav_circuit && (
									<CosmosText>
										Favourite Circuit:
										<br />
										<span>{activeProfile?.fav_circuit}</span>
									</CosmosText>
								)}

								{activeProfile?.fav_bull && (
									<CosmosText>
										Favourite Red Bull:
										<br />
										<span>{activeProfile?.fav_bull}</span>
									</CosmosText>
								)}

								{activeProfile?.fav_moment && (
									<CosmosText>
										Favourite Moment:
										<br />
										<span>{activeProfile?.fav_moment}</span>
									</CosmosText>
								)}

								{activeProfile?.fav_tune && (
									<CosmosText>
										Favourite Tune:
										<br />
										<span>{activeProfile?.fav_tune}</span>
									</CosmosText>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
